import React from "react";
import { BsTwitterX, BsInstagram, BsLinkedin } from "react-icons/bs";
import { PiCopyright } from "react-icons/pi";
import { TbGalaxy } from "react-icons/tb";
import { useLanguage } from "../Translations/LenguageContext";
import { HiTranslate } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";

const Footer = ({ NavigatePagesHome }) => {
    const { t, changeLanguage, language } = useLanguage()
    const navigate = useNavigate()
    const year = new Date().getFullYear();

    const handleLanguageChange = (event) => {
        changeLanguage(event.target.value);
    };

    const LegalNavigate = (page) => {
        navigate(`/${page}`)
    }

    return (
        <div className="footer_cont">
            <div className="end_footer">
                <div className="end_footer_item">
                    <p><PiCopyright /> {year} Abstracht.</p>
                    <p>{t.website.footer.all_rights}</p>
                    {/* <div className="change_language_cont">
                        <select className="language_select" onChange={handleLanguageChange} value={language}>
                            <option value="en">English</option>
                            <option value="it">Italiano</option>
                        </select>
                    </div> */}
                </div>
                <div className="end_footer_item">
                    <a href="/cookie-policy">Cookies</a>
                    <a href="/terms-and-conditions">{t.website.footer.legal}</a>
                    <a href="/privacy">{t.website.footer.privacy}</a>
                    <a href="/terms-and-conditions">{t.website.footer.terms}</a>
                </div>
                <div className="end_footer_item">
                    <div className="end_footer_socials">
                        <a href="https://www.linkedin.com/company/abstracht/" target="_blank" rel="noopener noreferrer">
                            <i><BsLinkedin /></i>
                        </a>
                          {/* <a href="https://x.com/AbstrachtLabs" target="_blank" rel="noopener noreferrer">
                            <i><BsTwitterX /></i>
                        </a> */}
                        {/* <p><i><BsInstagram /></i></p> */}
                        {/* <p><i><BsTwitterX /></i></p> */}
                    </div>
                </div>
            </div>
            <p className="t0comp_mex" dangerouslySetInnerHTML={{__html: t.website.footer.t0r}}></p>
        </div>
    )
}

export default Footer